import { faChevronDown, faQuestion, faSync, faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Col, Form, OverlayTrigger, Row, Toast, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import swal from 'sweetalert';
import { Utils } from '../../../shared/utils';
import { modalETLHelpOnChangeAction } from '../../../stores/actions/modalOnChange';
import { refreshJobListAction, uploadFilesChangeAction } from '../../../stores/actions/uploadFilesChange';
import ProgressBar from '../../Common/ProgressBar';
import ETLHelp from '../../Layout/ETLHelp';

import EtlJobList from '../Admin/components/EtlJobList';

import './etlContainerStyle.scss';
import etlService from './etlService';

class ETLContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            templates: [],
            haveFile: false,
            resetBtn: false,
            showPopover: false,
            showToast: false,
            showAllFileTypes: false,
            uploadFilesData: [],
            api: {
                response: {
                    status: '',
                    message: '',
                },
            },
        };

        this.uploadsAborted = false;

        this.etlService = new etlService();
        this.onChangeFile = this.onChangeFile.bind(this);
        this.showAllTypes = this.showAllTypes.bind(this);
        this.setfileTypeWrapperRef = this.setfileTypeWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.renderUploadPercent = this.renderUploadPercent.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.validateFile = this.validateFile.bind(this);
        this.addFile = this.addFile.bind(this);

        this.getAllTemplates = this.getAllTemplates.bind(this);
    }

    /**
     * Render ui elements
     */
    render() {
        const { templates, haveFile, resetBtn, uploadFilesData, showToast, api, showAllFileTypes } = this.state;
        const columns = [
            { Header: 'File Name', accessor: 'fileName', width: 400 },
            { Header: 'File Type', accessor: 'fileType', width: 150 },
            { Header: 'File Size', accessor: 'fileSize', width: 150 },
            { Header: 'Status', accessor: 'status' },
            {
                Header: 'Upload %',
                accessor: 'percentComplete',
                width: 250,
                Cell: this.renderUploadPercent,
            },
        ];
        let showHelp = false;
        if (this.props && this.props.modalETLHelp.payload && this.props.modalETLHelp.payload.status) {
            showHelp = true;
        }
        return (
            <div className="etl-view-container">
                <div>{showHelp ? <ETLHelp templates={templates} /> : null}</div>
                {!this.props.customerId ? (
                    <div>
                        <p id="actuals-no-customer-msg" className="text-center no-customer-msg">
                            Please select A Customer
                        </p>
                    </div>
                ) : (
                    <>
                        <Row className='help-padding'>
                            <Col md={6}>
                                <h5 className="mb-0 mt-3 ml-2">Selected Files:</h5>
                            </Col>
                            <Col md={6} className="text-center button-group mt-2">
                                <Row className="flex-wrap">
                                    <Col className="col-6 col-sm-6 col-md-6 col-lg-3 mb-lg-0 mb-2">
                                        <Form.Group className="form-inlinemb-2">
                                            <div className="type-dropdown top-z-index" ref={this.setfileTypeWrapperRef}>
                                                <div className="type-holder">
                                                    <div className="each-type" onClick={this.showAllTypes}>
                                                        <span>Select File</span>
                                                        <FontAwesomeIcon icon={faChevronDown} />
                                                    </div>
                                                </div>
                                                <div className={showAllFileTypes ? 'type-holder d-inline' : 'd-none'}>
                                                    {templates.map((tplt, idx) => (
                                                        <div key={`${tplt.fileType}-${idx}`} className="each-type">
                                                            {tplt.displayLabel}
                                                            <input
                                                                type="file"
                                                                id="etl-upload-btn"
                                                                data-tag={tplt.fileType}
                                                                className="dummy-fileInput"
                                                                title=""
                                                                onChange={(event) => {
                                                                    this.onChangeFile(event);
                                                                }}
                                                                onClick={(event) => {
                                                                    event.target.value = null;
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col className="col-6 col-sm-6 col-md-6 col-lg-3 mb-lg-0 mb-2">
                                        <Button
                                            id="save-btn"
                                            className="w-100 m-0 btn-save"
                                            size="sm"
                                            onClick={() => this.uploadAllFiles(uploadFilesData)}
                                            disabled={!haveFile ? 'disabled' : null}
                                        >
                                            <FontAwesomeIcon icon={faUpload} />
                                            <span className="ml-3">Upload Files</span>
                                        </Button>
                                    </Col>
                                    <Col className="col-6 col-sm-6 col-md-6 col-lg-3 mb-lg-0 mb-2">
                                        <Button
                                            id="reset-btn"
                                            className="w-100 m-0 btn-reload"
                                            size="sm"
                                            onClick={this.resetAllFiles}
                                            disabled={!resetBtn ? 'disabled' : null}
                                        >
                                            <FontAwesomeIcon icon={faSync} />
                                            <span className="ml-3">Reset</span>
                                        </Button>
                                    </Col>
                                    <Col className="col-6 col-sm-6 col-md-6 col-lg-3 mb-lg-0 mb-2">
                                        <OverlayTrigger
                                            key={'bottom'}
                                            placement={'bottom'}
                                            overlay={
                                                <Tooltip id={`tooltip-bottom'`}>Download Data File Templates</Tooltip>
                                            }
                                        >
                                            <Button
                                                id="cancel-btn"
                                                className="w-100 m-0 btn-close"
                                                size="sm"
                                                onClick={this.showETLHelp}
                                            >
                                                <FontAwesomeIcon icon={faQuestion} />
                                                <span className="ml-3">Help</span>
                                            </Button>
                                        </OverlayTrigger>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <div className="table-responsive-cm">
                                    <ReactTable
                                        columns={columns}
                                        data={uploadFilesData}
                                        noDataText={
                                            !this.props.ingestFileLocation
                                                ? 'No Pending Uploads'
                                                : 'No Files Selected'
                                        }
                                        minRows={uploadFilesData.length}
                                        showPagination={false}
                                        pageSize={uploadFilesData.length}
                                        className="-highlight cursor-pointer w-100"
                                        style={
                                            uploadFilesData.length >= 5
                                                ? {
                                                      height: 'calc(100vh - 400px)',
                                                  }
                                                : {}
                                        }
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <EtlJobList customerId={this.props.customerId} mode={'DATA'} />
                            </Col>
                        </Row>
                    </>
                )}

                <Toast className="toast-container" show={showToast} onClose={this.toggleToast}>
                    <Toast.Header className={` ${api.response.status !== 'Failure' ? 'success' : 'error'}`}>
                        <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                        <strong className="mr-auto">{api.response.status}</strong>
                    </Toast.Header>
                    <Toast.Body>{api.response.message}</Toast.Body>
                </Toast>
            </ div>
        );
    }

    /**
     * Show help component
     * */
    showETLHelp = () => {
        this.props.setModalETLHelpOpen({ status: true });
    };

    /**
     * Component will mount method
     */
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        this.getAllTemplates();
    }

    /**
     * Component will unmount method
     */
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Props change event handling
     */
    componentDidUpdate(prevProps) {
        if (prevProps.customerId !== this.props.customerId) {
            this.setState({
                uploadFilesData: [],
                haveFile: false,
                resetBtn: false,
                showToast: false,
            });
        }
    }

    getAllTemplates() {
        this.etlService.getEtlAllTemplates(this.props.customerId).then((res) => {
            if (res && res.status === 'Success') {
                this.setState({
                    templates: res.data,
                });
            }
        });
    }

    showAllTypes() {
        this.setState({
            showAllFileTypes: !this.state.showAllFileTypes,
        });
    }

    /**
     * ETL file upload change method
     * @param {event} event - uploaded files.
     */
    onChangeFile(event) {
        let etlFileType = event.target.getAttribute('data-tag');
        if (!etlFileType) return;
        event.stopPropagation();
        event.preventDefault();
        // Assigning file to variable
        const file = event.target.files[0];

        this.validateFile(etlFileType, file, () => {
            this.addFile(etlFileType, file);
        });
    }

    validateFile(etlFileType, file, proceed) {
        const fileSizeLimit = Number(process.env.REACT_APP_UPLOAD_FILE_SIZE_LIMIT || '4294967296');
        if (file.size > fileSizeLimit) {
            const maxFileSize = this.getFileSize(fileSizeLimit);
            swal({
                title: 'Selected File Too Large',
                text: 'File size exceeds the allowed limit of ' + maxFileSize + '\n' + file.name,
                icon: 'error',
                dangerMode: true,
            });
            return;
        }

        const HEADER_SIZE = 1024;
        const blob = file.slice(0, HEADER_SIZE);
        const reader = new FileReader();
        reader.onload = (event) => {
            const headerText = event.currentTarget.result;
            if (this.handleReadFileHeader(file, headerText)) {
                proceed();
            } else {
                swal({
                    title: 'Invalid Selected File',
                    text: '\nAllowed file types - XLSX, CSV, HL7, JSON\n' + file.name,
                    icon: 'error',
                    dangerMode: true,
                });
            }
        };
        reader.readAsBinaryString(blob);
    }

    handleReadFileHeader(file, headerText) {

        const fileTypes = ['.pgp', '.gpg'];

        if(file && fileTypes.some(type => file.name.includes(type))){
            return true;
        }

        // excel data file
        if (headerText.slice(0, 6) === '\x50\x4b\x03\x04\x14\x00') {
            return true;
        }

        // ascii text file - json, hl7, csv
        if (Utils.isAscii(headerText)) {
            return true;
        }

        return false;
    }

    addFile(etlFileType, file) {
        const { templates, uploadFilesData } = this.state;
        const fileTypeKey = templates.find((tplt) => tplt.fileType === etlFileType).formDataKey;

        // Setting properties for selected file to display in the table
        const fileProps = {
            file: file,
            fileName: file.name,
            fileKey: fileTypeKey,
            fileType: etlFileType,
            fileSize: this.getFileSize(file.size),
            percentComplete: -1,
            errors: '',
            errorSummary: [],
            status: "Ready to Upload - Select 'Upload Files'",
        };
        // Checking if a file already selected
        let index = uploadFilesData.findIndex((x) => x.fileName === file.name);
        if (index === -1) {
            // If  No, Pushing new file to state
            this.setState({
                haveFile: true,
                resetBtn: true,
                showAllFileTypes: false,
                uploadFilesData: [...uploadFilesData, fileProps],
            });
        } else {
            // If Yes, Replacing the exisiting file with newly selected file
            this.setState({
                haveFile: true,
                resetBtn: true,
                showAllFileTypes: false,
                uploadFilesData: [
                    ...uploadFilesData.slice(0, index),
                    Object.assign({}, uploadFilesData[index], fileProps),
                    ...uploadFilesData.slice(index + 1),
                ],
            });
        }
    }

    /**
     * Upload ETL files method
     */
    uploadAllFiles = (uploadFilesData) => {
        if (!this.state.haveFile) return;
        //const { uploadFilesData } = this.state;
        const files = uploadFilesData.map((file) => {
            const {
                fileType,
                file: { name, size, type, lastModified },
            } = file;
            return {
                fileType,
                fileProps: {
                    name,
                    size,
                    type,
                    lastModified,
                },
            };
        });

        console.log(" files :   ", files);

        const etlFormData = {
            customerId: this.props.customerId,
            files,
        };

        this.uploadsAborted = false;

    this.etlService.PresignUploadUrls(etlFormData).then((res) => {
        if (res && res.status === "Success") {
        const {
               data: {files}
           } = res;

        if (this.uploadsAborted) {
          return;
        }

                files.forEach((file, i) => {
                    const readyForUpload =
                        !uploadFilesData[i].percentComplete || uploadFilesData[i].percentComplete < 1;
                    if (file.signedUrl && !this.uploadsAborted && readyForUpload) {
                        this.uploadFile(file, uploadFilesData[i]);
                        uploadFilesData[i].errors = file.errors;
                        uploadFilesData[i].errorSummary = file.errorSummary;
                        uploadFilesData[i].status = file.status;
                    }
                });
                // Setting new state

                this.setState({
                    haveFile: false,
                    resetBtn: true,
                    showAllFileTypes: false,
                    uploadFilesData: uploadFilesData,
                    api: {
                        response: {
                            status: 'In Progress',
                            message:
                                'Data files are being uploaded. Check for errors in Job History after processing is completed.',
                        },
                    },
                });
                this.toggleToast();
                this.props.refreshJobList(new Date().getTime());
            } else {
                this.setState({
                    showAllFileTypes: false,
                    api: {
                        response: {
                            status: res.status,
                            message: res.message,
                        },
                    },
                });
                this.toggleToast();
            }
        });
    };

    uploadFile(file, fileStatusData) {
        const self = this;
         const { uploadFilesData } = this.state;
        console.log("Uploading file: " + file.fileProps.name);
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', file.signedUrl);
        xhr.upload.addEventListener('progress', (event) => {
            if (self.uploadsAborted) {
                xhr.abort();
                return;
            }
            if (event.lengthComputable) {
                let percentComplete = Math.floor((100 * event.loaded) / event.total);
                fileStatusData.status =
                    'Uploaded ' + self.getFileSize(event.loaded) + ' (' + event.loaded.toLocaleString() + ' bytes)';
                fileStatusData.loaded = event.loaded;
                fileStatusData.total = event.total;
                fileStatusData.name = file.fileProps.name;
                fileStatusData.percentComplete = percentComplete;
                self.props.updateUploadFilesData({ uploadFilesData: uploadFilesData });
            }
        });

        xhr.onreadystatechange = function () {
            if (self.uploadsAborted) {
                xhr.abort();
                return;
            }
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    // console.log('File uploaded successfully');
                    fileStatusData.status += ' - data is in queue for further processing';
                    fileStatusData.percentComplete = 100;
                } else {
                    // console.log('Error while sending the data file')
                    if (fileStatusData.status) {
                        fileStatusData.status += ' - failed ' + xhr.statusText;
                    } else {
                        fileStatusData.status = 'failed ' + xhr.statusText;
                    }
                }
                 self.props.updateUploadFilesData({ uploadFilesData: uploadFilesData });
            }
        };

        fileStatusData.loaded = 0;
        fileStatusData.percentComplete = 0;
        fileStatusData.status = 'Uploading...';
        self.props.updateUploadFilesData({ uploadFilesData: uploadFilesData });
        xhr.send(fileStatusData.file);
    }

    resetAllFiles = () => {
        const { uploadFilesData } = this.state;
        const progress = Utils.summarizeUploadFilesProgress(uploadFilesData);
        if (progress && progress.uploadingFileCount > 0) {
            const self = this;
            swal({
                title: 'Warning',
                text: 'Files are either staged for upload or uploading is in progress. Do you want to continue?',
                icon: 'warning',
                dangerMode: true,
                buttons: ['Cancel', 'Continue Reset'],
            }).then((reset) => {
                if (reset) {
                    this.uploadsAborted = true;
                    self.setState({
                        haveFile: false,
                        resetBtn: false,
                        uploadFilesData: [],
                    });
                    self.props.updateUploadFilesData({ uploadFilesData: [] });
                }
            });
        }
        else {
            const self = this;
            self.setState({
                haveFile: false,
                resetBtn: false,
                uploadFilesData: [],
            });
            self.props.updateUploadFilesData({ uploadFilesData: [] });
        }
    };

    /**
     * To return file size in KB,MB,GB,TB Format
     * @param {number} Size file size
     */
    getFileSize(size) {
        let type = 'KB';
        let convertedSize = size / 1024;
        if (convertedSize > 1024) {
            convertedSize = convertedSize / 1024;
            type = 'MB';
            if (convertedSize > 1024) {
                convertedSize = convertedSize / 1024;
                type = 'GB';
                if (convertedSize > 1024) {
                    convertedSize = convertedSize / 1024;
                    type = 'TB';
                }
            }
        }
        return convertedSize.toFixed(1) + ' ' + type;
    }

    /**
     * Toggle toast
     */
    toggleToast = () => {
        const { showToast } = this.state;
        this.setState({
            showToast: !showToast,
        });
        setTimeout(() => {
            this.setState({
                showToast: false,
            });
        }, 4000);
    };

    renderUploadPercent(cellInfo) {
        //console.log('renderUploadPercent ' + JSON.stringify(cellInfo.original));
        return <ProgressBar percentage={cellInfo.original.percentComplete} />;
    }

    /**
     * Invoke if clicked on outside of element.
     */
    handleClickOutside(event) {
        if (this.fileTypeWrapperRef && !this.fileTypeWrapperRef.contains(event.target)) {
            this.setState({ showAllFileTypes: false });
        }
    }

    /**
     * Set cusomer wrap reference
     * @param {*} node node
     */
    setfileTypeWrapperRef(node) {
        this.fileTypeWrapperRef = node;
    }
}

/**
 * Mapping redux state into props
 */
const MapStateToProps = (state) => {
    return {
        modalETLHelp: state.modalETLHelpOnChange,
    };
};

const MapDispatchToProps = (dispatch) => {
    return {
        setModalETLHelpOpen: (params) => dispatch(modalETLHelpOnChangeAction(params)),
        updateUploadFilesData: (params) =>
            dispatch(uploadFilesChangeAction(params)),
        refreshJobList: (params) => dispatch(refreshJobListAction(params)),
    };
};

ETLContainer.propTypes = {
    modalHelp: PropTypes.object.isRequired,
    customerId: PropTypes.number,
    modalETLHelp: PropTypes.shape({
        payload: PropTypes.shape({
            status: PropTypes.bool,
        }),
    }),
    ingestFileLocation: PropTypes.string,
    setModalETLHelpOpen: PropTypes.func,
    refreshJobList: PropTypes.func,
};

export default connect(MapStateToProps, MapDispatchToProps)(ETLContainer);
